"use client";

import { PAGE_ROUTE_ACTION_TYPE, QUERY_PARAMS, ROUTE } from "@constants/common";
import { Route } from "next";
import { UrlObject } from "url";

export const getLoginRoute = (isExpiredSession?: boolean) => {
	if (isExpiredSession) {
		return `${ROUTE.LOGIN}?${QUERY_PARAMS.SESSION_EXPIRED}=true`;
	}
	return `${ROUTE.LOGIN}`;
};

export const getOrganizationRoute = (queryParams?: string) => {
	return `${ROUTE.ORGANIZATIONS}${queryParams ?? ""}`
};

export const getProgramRoute = (programId: string | number, isStaging?: boolean, queryParams?: string) => {
	return `${ROUTE.ORGANIZATIONS}/clients/programs/${isStaging ? PAGE_ROUTE_ACTION_TYPE.EditStaging : PAGE_ROUTE_ACTION_TYPE.EditOrigin}/${programId}${queryParams ?? ""}`
};

export const getClientRoute = (clientId: string | number, isStaging?: boolean, queryParams?: string) => {
	return `${ROUTE.ORGANIZATIONS}/clients/${clientId}/${isStaging ? 'true' : 'false'}${queryParams ?? ""}`
};

export const getIssuerRoute = (issuerId: string | number, isStaging?: boolean, queryParams?: string) => {
	return `${ROUTE.ORGANIZATIONS}/issuers/${isStaging ? PAGE_ROUTE_ACTION_TYPE.EditStaging : PAGE_ROUTE_ACTION_TYPE.EditOrigin}/${issuerId}${queryParams ?? ""}`;
}

export const getProcessorRoute = (processorId: string | number, queryParams?: string) => {
	return `${ROUTE.ORGANIZATIONS}/processors/${processorId}/edit${queryParams ?? ""}`;
}

export const getPopulationDetailRoute = (id: string | number, isStaging?: boolean) => {
	return `${ROUTE.POPULATION_MANAGEMENT}/${isStaging ? PAGE_ROUTE_ACTION_TYPE.EditStaging : PAGE_ROUTE_ACTION_TYPE.EditOrigin}/${id}`;
};

export const getBalanceFactorDetailRoute = (id: string | number, isStaging?: boolean) => {
	return `${ROUTE.BALANCE_FACTORS}/${isStaging ? PAGE_ROUTE_ACTION_TYPE.EditStaging : PAGE_ROUTE_ACTION_TYPE.EditOrigin}/${id}`;
};

export const getUrlObject = (url: string) => {
	return url as unknown as UrlObject;
}

export const getRoute = (url: string) => {
	return url as Route;
}

export const getStateProfileDraftRoute = (id: string | number, isStaging?: boolean) => {
	return `${ROUTE.STATE_PROFILES}/edit?isdraft=${isStaging}&stateprofileid=${id}`;
}